import { Box, Flex, Text } from "@chakra-ui/react";
import PendingDarkIcon from "assets/svg/transactions-dark-icon";
import UsersCard from "components/card/UsersCard";
import { ROUTES } from "constants/routes";

interface PendingOverviewProps {
  loading: boolean;
  data: any | null;
}
const PendingAccountRequest = ({ loading, data }: PendingOverviewProps) => {
  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <Flex gap={3} alignItems="center">
        <PendingDarkIcon />
        <Text color="#000" fontSize={24} fontWeight={700} lineHeight={"24px"}>
          Pending Virtual Account Request
        </Text>
      </Flex>
      <Box display={`flex`} flexWrap={`wrap`} gap={`2rem`}>
        <UsersCard
          text="USD"
          totalValue={data?.pendingUsdVaRequest || 0}
          isLoading={loading}
          viewUsersType={`${ROUTES.USERS.path}?va_request=USD`}
        />
        <UsersCard
          text="GBP"
          totalValue={data?.pendingGbpVaRequest || 0}
          isLoading={loading}
          viewUsersType={`${ROUTES.USERS.path}?va_request=GBP`} 
        />
        <UsersCard
          text="EUR"
          totalValue={data?.pendingEurVaRequest || 0}
          isLoading={loading}
          viewUsersType={`${ROUTES.USERS.path}?va_request=EUR`}
        />
      </Box>
    </Box>
  );
};

export default PendingAccountRequest;
